import { CountryDetailsType } from '~/types/common.types'

export default function getCountryNamesFromCountryData(countriesData: CountryDetailsType[] | undefined): string[] {
  return countriesData?.map((countryDetails: { country: string }) => countryDetails.country) || []
}

export function getCountryNameFromCountryCodeAndData(
  countriesData: CountryDetailsType[] | undefined,
  countryCode: string | undefined,
): string {
  return (
    countriesData?.find((countryDetails: CountryDetailsType) => countryDetails.countryCode === countryCode)?.country ??
    ''
  )
}

export function getCountryCodeFromCountryNameAndData(
  countriesData: CountryDetailsType[] | undefined,
  countryName: string | undefined,
): string {
  return (
    countriesData?.find((countryDetails: CountryDetailsType) => countryDetails.country === countryName)?.countryCode ??
    ''
  )
}
